import { Button } from "@mui/material";
import React from "react";
import EditPasswordDialog from "./EditPasswordDialog";

const EditPasswordComponent = ({ translationObject }: any) => {
	const [openModal, setModalOpen] = React.useState(false);

	const handleModalClose = () => {
		setModalOpen(false);
	};

	return (
		<div
			className="Password"
			style={{ display: "flex", alignItems: "center", padding: "2rem" }}
		>
			<EditPasswordDialog
				openModal={openModal}
				handleModalClose={handleModalClose}
			/>
			<span
				style={{
					fontWeight: "bold",
					width: "70%",
					display: "inline-block",
				}}
			>
				Password
			</span>
			<Button
				style={{
					width: "12rem",
					height: "2.5rem",
					backgroundColor: "white",
					border: "2px solid #CCCCCC",
					borderRadius: "4px",
					color: "#747474",
				}}
				onClick={(e) => {
					setModalOpen(true);
				}}
			>
				{translationObject("account_security_settings.change_password")}
			</Button>
		</div>
	);
};
export default EditPasswordComponent;
